import { render, staticRenderFns } from "./ReceiptCommandQuery.vue?vue&type=template&id=2ffc9f97"
import script from "./ReceiptCommandQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptCommandQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports